import React from 'react';
import Footer from './Footer';
import Header from './Header';

interface LayoutTypes {
  children: React.ReactNode;
  location: Location;
}

const Layout = ({ children, location }: LayoutTypes) => {
  return (
    <>
      <Header location={location} />
      <main className='grid grid-colums-12 xl:container py-10 z-0 px-4 md:px-8 xl:px-16'>{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
